'use client'

import { useEffect, useState } from 'react'
import { AccordionTracker } from './AccordionTracker.component'

interface TrackerTransactions {
  transactions: any[]
}

export function TrackerTransactionsFetcher() {
  const [transactions, setTransactions] = useState<TrackerTransactions | null>(
    null,
  )
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchTrackerTransactions = async () => {
      try {
        const response = await fetch('/api/tracker-transactions')
        if (!response.ok) {
          throw new Error('Failed to fetch transactions.')
        }
        setTransactions(await response.json())
      } catch (error) {
        console.error('Error fetching transactions:', error)
        setError('Failed to load transactions.')
      } finally {
        setLoading(false)
      }
    }

    fetchTrackerTransactions()
  }, [])

  if (error) {
    return (
      <div className="paragraph-xl flex w-full justify-center">{error}</div>
    )
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center">
        <div
          className="h-8 w-8 animate-spin rounded-full border-4 border-base-dark border-t-transparent"
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }

  return <AccordionTracker items={transactions} />
}
